type AllRulesType = 'ALL' | 'ALL_ASSESS' | 'ALL_PROTECT'

export const allRulesTypeI18n: Record<AllRulesType, string> = {
  ALL: 'title_allRules',
  ALL_ASSESS: 'title_allAssessRules',
  ALL_PROTECT: 'title_allProtectRules'
}

export const allRulesType: Record<AllRulesType, AllRulesType> = {
  ALL: 'ALL',
  ALL_ASSESS: 'ALL_ASSESS',
  ALL_PROTECT: 'ALL_PROTECT'
}
